export default {
  PROGRESS_SELECT: 'PROGRESS_SELECT',
  PROGRESS_PENDING: 'PROGRESS_PENDING',
  PROGRESS_UPDATED: 'PROGRESS_UPDATED',
  PROGRESS_COMPLETE: 'PROGRESS_COMPLETE',
  PROGRESS_ERROR: 'PROGRESS_ERROR',
}